import React from "react";
import { Reveal } from "./Section";

/**
 * PartnersLogosCarousel — défilement automatique en boucle des logos partenaires
 * (Hiscox, MADP, Allianz, …). Style noir & blanc premium : logos en niveaux
 * de gris sur fond crème, animation CSS marquee sans lib externe.
 *
 * Affiché UNIQUEMENT sur la page Assurance / Pro (pas sur la home).
 */
const PARTNERS = [
  { src: "/logos/partners/generali.png", alt: "Generali" },
  { src: "/logos/partners/groupama.png", alt: "Groupama" },
  { src: "/logos/partners/axa.png", alt: "AXA" },
  { src: "/logos/partners/hiscox.png", alt: "Hiscox — Assurance professionnelle" },
  { src: "/logos/partners/hiscox-assurances.png", alt: "Hiscox Assurances" },
  { src: "/logos/partners/axeria.png", alt: "Axeria" },
  { src: "/logos/partners/madp.png", alt: "MADP — Mutuelle d'assurance des professionnels" },
  { src: "/logos/partners/allianz.jpg", alt: "Allianz" },
];

// On répète 2x pour boucler en marquee CSS sans saut
const LOOP = [...PARTNERS, ...PARTNERS, ...PARTNERS, ...PARTNERS];

export default function PartnersLogosCarousel() {
  return (
    <section
      data-testid="partners-logos-carousel"
      className="relative py-16 md:py-20 bg-white border-y border-brand-border overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 text-center mb-10">
        <Reveal>
          <div className="overline">Mes partenaires assureurs</div>
        </Reveal>
        <Reveal delay={1}>
          <p className="mt-4 text-brand-ink/65 text-[15px] md:text-base leading-relaxed font-light max-w-2xl mx-auto">
            Je travaille avec un large panel de compagnies pour vous offrir le choix le plus
            adapté à votre situation.
          </p>
        </Reveal>
      </div>

      <div
        className="relative w-full overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <div className="flex items-center gap-16 md:gap-20 animate-marquee whitespace-nowrap">
          {LOOP.map((p, i) => (
            <div
              key={i}
              data-testid={`partner-logo-${i}`}
              className="shrink-0 h-14 md:h-16 flex items-center"
            >
              <img
                src={p.src}
                alt={p.alt}
                className="h-full w-auto object-contain grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-25%); }
        }
        /* Durée d'un tour complet du marquee — modifiable ici (valeur unique) */
        .animate-marquee {
          animation: marquee 6s linear infinite;
          will-change: transform;
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-marquee { animation: none; }
        }
      `}</style>
    </section>
  );
}
